import axios from "axios";

const CekScheduleAPI = async (token) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const params = `/schedule/check?token=${token}`;
    const url = `${BASED_URL}${params}`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    return err.response;
  }
};

export default CekScheduleAPI;
